export default __webpack_public_path__ + "static/media/DSC_7729-edited.591356b3.png";